// ErrorMessageModal.jsx
import React from 'react';
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../../../components/ui/alert-dialog';
import { Button } from '../../../components/ui/button';

const ErrorMessageModal = ({ open, handleClose, data }) => {
    return (
        <AlertDialog open={open} onDismiss={handleClose}>
            <AlertDialogContent>
                <AlertDialogHeader className="flex flex-row justify-between space-0">
                    <AlertDialogTitle className="text-lg flex-grow font-medium inline mb-4">
                        Error Details
                    </AlertDialogTitle>
                    <button onClick={handleClose} className="bg-none border-none cursor-pointer text-sm">
                        ✕
                    </button>
                </AlertDialogHeader>
                <AlertDialogDescription className="hidden" />
                <div className='flex flex-col space-y-4 w-full'>
                    <p><strong>Version: </strong>{data?.title || 'N/A'}</p>
                    <p><strong>Key: </strong>{data?.key || 'N/A'}</p>
                    <p><strong>Status: </strong>{data?.status || 'N/A'}</p>
                    {data?.calculated_on && <p><strong>Failed On: </strong>{data.calculated_on}</p>}
                    <div>
                        <p className="mb-2"><strong>Error Message:</strong></p>
                        <div className="bg-red-50 border border-red-200 rounded-md p-3 max-h-64 overflow-y-auto">
                            <pre className="text-sm text-red-800 whitespace-pre-wrap break-words">
                                {data?.error_message || 'No error message available'}
                            </pre>
                        </div>
                    </div>
                </div>
                <AlertDialogFooter>
                    <Button type="button" onClick={handleClose}>Close</Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default ErrorMessageModal;